<template>
  <el-date-picker
      v-model="getPeriod"
      type="daterange"
      align="right"
      unlink-panels
      :clearable="false"
      range-separator="До"
      format="dd.MM.yyyy"
      start-placeholder="нач. период"
      end-placeholder="конеч. период"
      size="mini"
      @change="handleChange"
      :picker-options="pickerOptions"
      :default-time="defaultTime"
  />
</template>

<script>
// config
import { getPickerOptions } from "./config";

// libraries
import moment from "moment/moment";

// actions
import { SET_GLOBAL_MAIN_PERIOD } from "../../store/actions/datePeriod";

export default {
  name: "PeriodRange",
  props: {
    chartName: {
      type: String
    },
    toDate: {
      type: String
    },
    fromDate: {
      type: String
    }
  },
  data() {
    return {
      defaultTime: ["00:00:00", "23:59:59"],
      format: "YYYY-MM-DD HH:mm:ss",
      title: "",
      isChanged: false,
      localPeriod: null,
    };
  },
  methods: {
    handleChange() {
      this.isChanged = true;
    },
    getMethod({method, title}) {
      this.method = method;
      this.title = title;
    }
  },
  computed: {
    pickerOptions() {
      return getPickerOptions(
          this.$store.getters.retrospective(this.$route.params.threadId),
          `${this.toDate.split(' ')[0]} 23:59:59`,
          this.getMethod,
          this.chartName,
      );
    },
    getPeriod: {
      get() {
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date(this.localPeriod[1])
        return [`${condition ? retrospective : this.localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : this.localPeriod[1].split(' ')[0]} 23:59:59`.replace(" ", "T")];
      },
      set(period) {
        this.localPeriod = period.map(item => moment(item).format(this.format));

        this.$emit('setPeriod', {
          period,
          payload: {
            chart: this.chartName,
            period: period.map(item => moment(item).format(this.format)),
            title: this.title,
            method: this.method,
            thread: this.$route.params.threadId,
            toDate: `${this.toDate.split(' ')[0]} 23:59:59`
          }
        });
      }
    }
  },
  beforeMount() {
    //this.localPeriod = [this.toDate, this.toDate];
    //this.localPeriod = typeof this.toDate == "string" ? ['', ''] : this.$store.getters.getMainPeriod;
    const period = this.$store.getters.getMainPeriod;
    this.localPeriod = [period[0], `${period[1].split(' ')[0]} 23:59:59`]
    this.$store.dispatch(SET_GLOBAL_MAIN_PERIOD, {
            chart: this.chartName,
            period: this.localPeriod,
            title: this.title,
            method: this.method,
            thread: this.$route.params.threadId
    });
  }
};
</script>

<style>
.el-picker-panel__content.el-date-range-picker__content.is-right{
  display: none;
}
.el-date-range-picker.has-sidebar {
    width: 365px;
}
@media screen and (max-width: 480px) {
  .el-date-range-picker__header div {
    font-size: 12px;
    line-height: initial;
    display: contents;
    margin-left: 5px!important;
    margin-right: 5px!important;
  }
}

</style>
